angular.module('TetherApp').factory('eventService', [
    '$http',
    function ($http) {
        let requeueEvent = function (eventId) {
            return $http.post(
                '/api/v1/events/' + eventId + '/requeue',
                {},   //OBJECT
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            ).then(
                function (response) {
                    return response.data;
                }
            );
        };

        let requeueEmail = function (eventId) {
            return $http.post(
                '/api/v1/events/' + eventId + '/requeue-email',
                {},   //OBJECT
                {
                    cache: false,
                    headers: { 'Cache-Control': 'no-cache' }
                }
            ).then(
                function (response) {
                    return response.data;
                }
            );
        };

        return {
            requeueEvent: requeueEvent,
            requeueEmail: requeueEmail
        };
    }
]);
